export default "__VITE_ASSET__9ddef180__"